import HeroBannerContainer from './HeroBannerContainer';

export default HeroBannerContainer;
